module.exports = __webpack_public_path__ + "img/oeuf.1140d70f.png";